import { util } from 'echarts/core';
import { ThemeParser } from '../../../core/theme';
import { normalizeToArray } from '../../../util/utils';
import { parseBarGap } from '../../mobile/series/bar';

function parseDynamicHistogramBar(option: Parameters<ThemeParser>[0]) {
  option.series = option.series.map(item => {
    return util.merge(
      {
        seriesLayoutBy: 'column',
        type: 'bar',
        barMaxWidth: 16,
        emphasis: {
          disabled: true
        },
        itemStyle: {
          color: '#E93030'
        },
        label: {
          show: true,
          precision: 0.1,
          position: 'right',
          valueAnimation: true,
          color: '#1E2024',
          fontSize: 14,
          formatter(data) {
            return `$${Math.floor(data.value[0])}`;
          }
        }
      },
      item,
      true
    );
  });
}

export function judgeIsDynamicBar(barSeries: any[]) {
  return barSeries.some(item => item.realtimeSort !== undefined);
}

export function dynamicBarThemeParse(...args: Parameters<ThemeParser>): ReturnType<ThemeParser> {
  const option = args[0];
  const series = normalizeToArray(option.series);
  if (judgeIsDynamicBar(series)) {
    parseDynamicHistogramBar(option);
    parseBarGap(series, ...args);
  }
}
